(function () {

    angular
        .module('smartertoolsApp')
        .controller('partnerSuspendedController', ['$scope', '$location', partnerSuspendedController]);

    function partnerSuspendedController($scope, $location) {
        var vm = this;
        vm.goToInvoices = goToInvoices;

        // -----------------------------------------------

        function goToInvoices() {
            $location.path('/Invoices');
            $scope.$applyAsync();
        }
    }
})();